export default "__VITE_ASSET__6d3d0cbf__"